import { render, staticRenderFns } from "./CombinedResultPointAnalysisWidget.vue?vue&type=template&id=4cec8ef1"
import script from "./CombinedResultPointAnalysisWidget.vue?vue&type=script&lang=js"
export * from "./CombinedResultPointAnalysisWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports